import _, { isEmpty } from 'lodash';
import find from 'lodash-es/find';
import get from 'lodash-es/get';
import history from './history';
import routeConstants from './routeConstants';

export const getCurrentRouteDetails = (location: Partial<Location>) => {
  if (!get(location, 'pathname')) {
    return null;
  }
  const route = find(
    Object.keys(routeConstants),
    (key) => routeConstants[key].route === location.pathname || `${routeConstants[key].route}/` === location.pathname
  );
  if (route) {
    return routeConstants[route];
  }
  return null;
};
export const mapKeysDeep = <T>(obj: T, fn: (key: string) => string): T =>
  Array.isArray(obj)
    ? obj.map((val) => mapKeysDeep(val, fn))
    : typeof obj === 'object'
    ? Object.keys(obj).reduce((acc, current) => {
        const key = fn(current);
        const val = obj[current as keyof T];
        acc[key] = val !== null && typeof val === 'object' ? mapKeysDeep(val, fn) : val;
        return acc;
      }, {} as any)
    : obj;

export const isLocal = () => {
  try {
    if (process.env.IS_LOCAL) {
      const local = JSON.parse(process.env.IS_LOCAL);
      return typeof local === 'boolean' && local;
    }
  } catch {
    // continue regardless of error
  }
  return false;
};

export const isDev = () => {
  return process.env.ENVIRONMENT_NAME === 'development';
};
export const isQa = () => {
  try {
    if (process.env.IS_QA) {
      const qa = JSON.parse(process.env.IS_QA);
      return typeof qa === 'boolean' && qa;
    }
  } catch {
    // continue regardless of error
  }
  return false;
};

export const isProd = () => {
  return process.env.ENVIRONMENT_NAME === 'production';
};

interface SetQueryParamOptions {
  param: string;
  value?: string | number;
  deleteParam?: boolean;
  historyOp?: 'push' | 'replace';
}

export const setQueryParam = ({ param, value, deleteParam, historyOp = 'push' }: SetQueryParamOptions) => {
  const urlParams = new URLSearchParams(history.location.search);
  if (deleteParam) {
    urlParams.delete(param);
  } else {
    urlParams.set(param, String(value));
  }
  if (typeof history[historyOp] === 'function') {
    history[historyOp]({ search: urlParams.toString() });
  } else {
    throw new Error('Invalid history operation');
  }
};

export const prepare = (payload: any) => ({ payload });

export const bytesToMegaByte = (bytes: any) => parseFloat((bytes / (1024 * 1024)).toFixed(2));

export const isListOfObjectsNotEmpty = (list: any[]) => {
  for (let i = 0; i < list.length; i++) {
    if (!isEmpty(list[i]) && Object.values(list[i])[0]) {
      return true;
    }
  }

  return false;
};

export const isNotNullOrUndefined = (value: any) => {
  return value !== undefined && value !== null;
};
